type Evaluator = (value: any) => boolean;
function removeDeepArrayWalk(arr: any[], evaluator: Evaluator): any {
  return arr.map((val) => {
    if (Array.isArray(val)) return removeDeepArrayWalk(val, evaluator);
    else if (typeof val === 'object') return removeDeep(val, evaluator);
    return val;
  });
}

function removeDeep(obj: any, evaluator: Evaluator) {
  const keys: string[] = Object.keys(obj);
  const newObj: any = {};
  keys.forEach((i) => {
    if (evaluator(obj[i]) === false) {
      const val = obj[i];
      if (Array.isArray(val)) {
        newObj[i] = removeDeepArrayWalk(val, evaluator);
      } else if (typeof val === 'object' && val !== null) {
        newObj[i] = removeDeep(val, evaluator);
      } else newObj[i] = val;
    }
  });
  return newObj;
}

export default removeDeep;
